import React from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';

const ThankYou = () => {
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  };

  const mainContentStyle = {
    display: 'flex',
    flex: 1,
  };

  const contentAreaStyle = {
    flex: 1,
    padding: '20px',
  };

  const thankYouBoxStyle = {
    marginTop: '100px',
    textAlign: 'center',
  };

  const headingStyle = {
    fontSize: '36px',
    color: 'green',
    marginBottom: '20px',
    fontWeight: 'bold',
  };

  const paragraphStyle = {
    fontSize: '18px',
    color: '#555',
  };

  return (
    <div style={containerStyle}>
     
      <div style={mainContentStyle}>
        
        <div style={contentAreaStyle}>
          <div style={thankYouBoxStyle}>
            <h1 style={headingStyle}>Thank You!</h1>
            <p style={paragraphStyle}>Your payment has successfully completed.</p>
          </div>
        </div>
      </div>
    
    </div>
  );
};

export default ThankYou;
